import { TrashIcon } from "@heroicons/react/24/outline";
import dayjs from "dayjs";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { ITripType } from "../../../../interfaces/endpoints/trips/Trips.types";
import Input from "../../../ui/input/Input";
import { SelectOption } from "../../../ui/input/Input.types";
import SelectInput from "../../../ui/input/SelectInput";
import useTimeList from "../../../ui/input/TimePicker";
interface EmptyLineTripProps {
  editMode?: boolean;
  options?: { name: string; id: number }[];
  index: number;
  handleDelete: (id: number) => void;
  tripIndex?: number;
}

const EmptyLineTrip: React.FC<EmptyLineTripProps> = ({
  editMode,
  options,
  index,
  handleDelete,
  tripIndex
}) => {
  const {
    register, getValues, setValue, formState: { errors }
  } = useFormContext<ITripType>();

  const [openDropdown, setOpenDropdown] = useState<string | null>(null);

  const updateDuration = () => {
    const dt = dayjs(
      `2000-01-01 ${getValues(`schedules.${index}.departureTimeString`)}`
    );
    const at = dayjs(
      `2000-01-01 ${getValues(`schedules.${index}.arrivalTimeString`)}`
    );
    const durationSchedules: number = Number(dt.diff(at, "minutes", true));
    setValue(`schedules.${index}.duration`, durationSchedules);
  };

  const times = useTimeList();

  const toggleDropdown = (dropdown: string) => {
    setOpenDropdown((current) => current === dropdown ? null : dropdown);
  };

  const handleOptionSelect = (formField: string, option: SelectOption) => {
    const value = formField.includes("TimeString") ? option.id : Number(option.id);
    setValue(formField as any, value, { shouldValidate: true });
    setOpenDropdown(null);

    if (formField.includes("departureTimeString")) {
      setValue(`schedules.${index}.arrivalTimeString`, option.id as string);
      setTimeout(updateDuration, 0);
    }
  };

  return (
    <div className="flex-row flex items-center justify-between">
      <div className="mb-6 px-2 w-full md:w-2/3">
        {!editMode ? (
          <SelectInput
            options={options || []}
            label="Zgjedh ndalesën"
            placeholder="Zgjedh"
            selectedId={getValues(`schedules.${index}.stationId`)}
            isOpen={openDropdown === `station-${index}`}
            onClick={() => toggleDropdown(`station-${index}`)}
            onOptionSelect={(option) => handleOptionSelect(`schedules.${index}.stationId`, option)}
            error={errors?.schedules?.[index]?.stationId?.message}
          />
        ) : (
          <Input
            {...register(`schedules.${index}.stationId`)}
            label="Ndalesa e zgjedhur"
            className="pointer-events-none"
            inputClassName="h-11"
          />
        )}
      </div>
      <div className="w-full md:w-1/2 flex items-center">
        <div className="mb-6 w-5/6 md:w-full px-3">
          <SelectInput
            label="Ora e nisjes"
            options={times}
            selectedId={getValues(`schedules.${index}.departureTimeString`)}
            isOpen={openDropdown === `departure-${index}`}
            onClick={() => toggleDropdown(`departure-${index}`)}
            onOptionSelect={(option) => handleOptionSelect(`schedules.${index}.departureTimeString`, option)}
            error={errors?.schedules?.[index]?.departureTimeString?.message}
          />
        </div>
        <div className="hidden mb-6 w-1/2 pr-3">
          <Input
            type="text"
            {...register(`schedules.${index}.arrivalTimeString`)}
            label="Ora e arritjes"
            step="300"
            inputClassName="h-11 rounded-lg"
            onBlur={updateDuration}
          />
        </div>
        <input
          hidden
          value={0}
          {...register(`schedules.${index}.duration`, { valueAsNumber: true })}
        />
        <input
          value={tripIndex}
          {...register(`schedules.${index}.tripId`)}
          hidden
        />
        <span
          className="transition-colors hover:bg-gray-200 cursor-pointer rounded-full flex
        bg-gray-200 md:bg-transparent
        items-center justify-center w-10 h-9"
          onClick={() => handleDelete(index)}
        >
          <TrashIcon className="w-4 h-4 text-neutral" />
        </span>
      </div>
    </div>
  );
};

export default EmptyLineTrip;
